import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { getAction } from "@/api/manage";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import { mixinDevice } from "@/utils/mixin.js";
import "@/assets/less/animation.css";
import LightBox from 'vue-image-lightbox';
require('vue-image-lightbox/dist/vue-image-lightbox.min.css');
export default {
  mixins: [mixinDevice],
  components: {
    JDictSelectTag: JDictSelectTag,
    LightBox: LightBox
  },
  data: function data() {
    return {
      dataSource: [],
      pagination: {
        onChange: function onChange(page) {
          console.log(page);
        },
        pageSize: this._isMobile() ? 8 : 12
      },
      loading: true,
      productType: "",
      tenantConfig: {},
      lightBoxMedia: [],
      currentItem: {},
      queryParam: {
        cmsType: 10,
        pageSize: 999,
        cmsStatus: 1,
        eventId: '',
        orderBy: 'time'
      }
    };
  },
  created: function created() {
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    this.getList();
  },
  mounted: function mounted() {},
  methods: {
    eventChange: function eventChange(v) {
      this.queryParam.eventId = v.target.value;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      this.loading = true;
      this.dataSource = [];
      getAction("/teaching/teachingCms/getCmsList", this.queryParam).then(function (res) {
        console.log(res);
        if (res.success) {
          _this.dataSource = res.result.records;
        }
        _this.loading = false;
      });
    },
    toDetail: function toDetail(item) {
      //使阅读量+1
      getAction("/teaching/teachingCms/getCmsDetail?id=" + item.id);
      var that = this;
      var fileNames = [];
      if (item.extraFilename) {
        fileNames = JSON.parse(item.extraFilename);
        console.log(fileNames);
      }
      if (item.extraFile) {
        this.lightBoxMedia = item.extraFile.split(",").map(function (f) {
          var fn = "";
          if (f in fileNames) {
            fn = fileNames[f];
          }
          return {
            thumb: that.getQiniuUrl(f),
            src: that.getQiniuUrl(f),
            caption: fn
          };
        });
        this.$refs.lightbox.showImage(0);
      } else {
        this.$message.warning("没有图像");
      }
    },
    getQiniuUrl: function getQiniuUrl(text) {
      if (!text) {
        this.$message.warning("未知的文件");
        return;
      }
      if (text.indexOf(",") > 0) {
        text = text.substring(0, text.indexOf(","));
      }
      if (text.startsWith("http")) {
        return text;
      }
      return this.tenantConfig.qiniuDomain + "/" + text;
    }
  }
};